import {
  get,
  head,
  flatMapDeep,
  values,
  isString,
  mergeWith,
  isArray,
  isEmpty,
  isUndefined,
  has,
} from 'lodash-es'

import { getRelatedIncludes } from '@/js/helper/relationships-helper'
import { getItemName } from '@/js/helper/aimeos-name-helper'

import API_CONSTANTS from '@/js/helper/api-constants'
import BIKE_ATTRIBUTES from '@/js/helper/bike-attributes.js'

export const getFormattedAttributeItem = attribute => {
  return {
    [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.ID]: get(
      attribute,
      API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.ID,
    ),
    [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.LABEL]: get(
      attribute,
      API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.LABEL,
    ),
    [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.TYPE]: get(
      attribute,
      API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.TYPE,
    ),
    [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.CODE]: get(
      attribute,
      API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.CODE,
    ),
  }
}

export const createFormattedAttributesObject = ({ attributes, included }) =>
  attributes.reduce((result, attribute) => {
    const attrType = get(attribute, API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.TYPE)
    // console.log('createFormattedAttributesObject', attrType, attribute)
    if (!has(result, attrType)) {
      result[attrType] = []
    }
    result[attrType].push({
      [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.ID]: get(
        attribute,
        API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.ID,
      ),
      [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.LABEL]: get(
        attribute,
        API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.LABEL,
      ),
      [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.CODE]: get(
        attribute,
        API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.CODE,
      ),
      [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.TYPE]: get(
        attribute,
        API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.TYPE,
      ),
      [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.NAME]: included
        ? getAttributeName({ attribute, included })
        : get(attribute, API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.LABEL),
    })
    return result
  }, {})

export const createFormattedAttributeObject = ({ attributes, included }) =>
  attributes.reduce((result, attribute) => {
    result[get(attribute, API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.TYPE)] = {
      [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.ID]: get(
        attribute,
        API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.ID,
      ),
      [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.LABEL]: get(
        attribute,
        API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.LABEL,
      ),
      [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.CODE]: get(
        attribute,
        API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.CODE,
      ),
      [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.TYPE]: get(
        attribute,
        API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.TYPE,
      ),
      [API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.NAME]: included
        ? getAttributeName({ attribute, included })
        : get(attribute, API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.LABEL),
    }
    return result
  }, {})

export const createFormattedCategoryAttributeObject = ({ attributes, included }) =>
  attributes.reduce((result, attribute) => {
    const code = get(attribute, API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.CODE)?.split('|').pop()
    const labelJson = getCategoryAttributeLabel({ code, attribute, included })
    let label = ''

    try {
      label = JSON.parse(labelJson)[code]
    } catch (err) {
      console.info(
        'api has been called without include, transform product has no JSON data for label',
      )
    }

    result = {
      id: get(attribute, API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.ID),
      code,
      label,
    }
    return result
  }, {})

export const getCategoryAttributeLabel = ({ attribute, included }) =>
  getAttributeName({ attribute, included })

export const getAttributeName = ({ attribute, included }) =>
  getItemName({ item: attribute, included })

// export const getAttributeName = ({ attribute, included }) => {
//   const attrTexts = getRelatedIncludes({
//     relationships: get(attribute, API_CONSTANTS.RELATIONSHIPS, {}),
//     included,
//     type: API_CONSTANTS.AIMEOS.TYPE.TEXT,
//   })
//   const nameItem = head(
//     attrTexts.filter(text => {
//       return get(text, API_CONSTANTS.AIMEOS.TEXT.PATHS.TYPE) === API_CONSTANTS.AIMEOS.TEXT.TYPE.NAME
//     }),
//   )
//   const name = nameItem ? get(nameItem, API_CONSTANTS.AIMEOS.TEXT.PATHS.CONTENT) : undefined
//   return name || get(attribute, API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.LABEL)
// }

export const getFormattedAttributeItems = attributes => attributes.map(getFormattedAttributeItem)

export const getPropOrAttrPaths = attribute => {
  const type = get(attribute, API_CONSTANTS.TYPE, '')
  return type === API_CONSTANTS.AIMEOS.TYPE.PRODUCT_PROPERTY
    ? API_CONSTANTS.AIMEOS.PRODUCT_PROPERTY.PATHS
    : API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS
}

export const getPathToAttributeType = attribute => {
  return getPropOrAttrPaths(attribute)?.TYPE
}

export const filterAttributeByGroup = group => attribute =>
  group.includes(get(attribute, getPathToAttributeType(attribute)))

export const getAttributeItem = ({ attributes, key } = {}) =>
  attributes.filter(attribute => get(attribute, getPathToAttributeType(attribute)) === key)

export const getAttributeItemsByGroup = ({ attributes, group } = {}) =>
  attributes.filter(filterAttributeByGroup(group))

export const getFormattedColorAttributes = (attributes, included) =>
  createFormattedAttributeObject({
    attributes: getAttributeItemsByGroup({ attributes, group: BIKE_ATTRIBUTES.GROUP.COLOR }),
    included,
  })

export const getFormattedSelectVariantAttributes = (attributes, included) =>
  createFormattedAttributesObject({
    attributes: getAttributeItemsByGroup({
      attributes,
      group: BIKE_ATTRIBUTES.GROUP.SELECTVARIANT,
    }),
    included,
  })

export const getFormattedUpgradeAttributes = (attributes, included, clients) => {
  const upgradeAttributes = createFormattedAttributesObject({
    attributes: getAttributeItemsByGroup({
      attributes,
      group: BIKE_ATTRIBUTES.GROUP.UPGRADES,
    }),
    included,
  })

  console.log('🚀 ~ getFormattedUpgradeAttributes ~ upgradeAttributes:', upgradeAttributes)

  return head(
    (upgradeAttributes?.[BIKE_ATTRIBUTES.TYPE.UPGRADE_BATTERY_DATA] || [])
      .map(upgradeChoice => {
        console.log('🚀 ~ upgradeChoices ~ upgradeChoice:', upgradeChoice)
        try {
          const data = JSON.parse(
            upgradeChoice?.[API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.NAME] || '{}',
          )
          console.log('🚀 ~ upgradeChoices ~ data:', data)
          return Object.entries(data)
            .filter(([client, upgrades]) => clients.includes(client))
            .reduce((clientUpgrades, [client, upgrades]) => {
              clientUpgrades[client] = upgrades.reduce((upgradeTypes, upgrades) => {
                upgradeTypes[upgrades.group] = upgrades
                return upgradeTypes
              }, {})
              return clientUpgrades
            }, {})
        } catch {
          console.log('🚀 ~ upgradeChoices ~ catch')
          return undefined
        }
      })
      .filter(i => !isUndefined(i)),
  )
}

export const getSpecsAttributes = (attributes, group = flatBikeAttributsSpecList()) =>
  getAttributeItemsByGroup(
    {
      attributes,
      group,
    },
    [],
  )

export const getSpecsAttributesFormatted = ({
  attributes,
  included,
  group = flatBikeAttributsSpecList(),
}) =>
  createFormattedAttributeObject({
    attributes: getSpecsAttributes(attributes, group),
    included,
  })

export const flatBikeAttributsSpecList = () =>
  flatMapDeep(BIKE_ATTRIBUTES.SPEC_LIST, item => {
    return isString(item) ? item : values(item)
  })

// Used by mergeWith fuction
export const mergeValuesToArrays = (objValue, srcValue) => {
  // console.log(objValue, srcValue)
  const srcValueArray = isArray(srcValue)
    ? srcValue
    : isEmpty(srcValue) || isUndefined(srcValue)
    ? []
    : [srcValue]
  const objValueArray = isArray(objValue)
    ? objValue
    : isEmpty(objValue) || isUndefined(objValue)
    ? []
    : [objValue]
  return objValueArray.concat(srcValueArray)
}

export const getSpecsAttributesFromVariants = ({ variantProducts = [], included = [] }) => {
  const group = flatBikeAttributsSpecList()
  return variantProducts.reduce((attributesResult, variant) => {
    const attributes = getRelatedIncludes({
      relationships: get(variant, API_CONSTANTS.RELATIONSHIPS, {}),
      included,
      type: API_CONSTANTS.AIMEOS.TYPE.ATTRIBUTE,
    })
    const specAttributesFormatted = getSpecsAttributesFormatted({ attributes, group, included })
    if (isEmpty(attributesResult)) {
      attributesResult = specAttributesFormatted
    } else {
      mergeWith(attributesResult, specAttributesFormatted, mergeValuesToArrays)
    }
    return attributesResult
  }, {})
}

export const getFormattedFrameSizeAttributes = attributes =>
  createFormattedAttributeObject({
    attributes: getAttributeItemsByGroup({ attributes, group: BIKE_ATTRIBUTES.GROUP.FRAMESIZE }),
  })

export const getFrameSize = attributes =>
  get(getFormattedFrameSizeAttributes(attributes), [
    BIKE_ATTRIBUTES.TYPE.ITEM_FRAME_SIZE_CODE,
    API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.LABEL,
  ])

export const getFrameSizeCm = attributes =>
  createFormattedAttributeObject({
    attributes: getAttributeItemsByGroup({
      attributes,
      group: BIKE_ATTRIBUTES.TYPE.ITEM_FRAME_SIZE_CM,
    }),
  })

export const getProductSeason = attributes =>
  createFormattedAttributeObject({
    attributes: getAttributeItemsByGroup({
      attributes,
      group: BIKE_ATTRIBUTES.TYPE.PRODUCT_SEASON,
    }),
  })

export const getFrameType = (attributes = [], included = []) =>
  createFormattedAttributeObject({
    attributes: getAttributeItemsByGroup({ attributes, group: BIKE_ATTRIBUTES.GROUP.FRAMETYPE }),
    included,
  })

export const getWheelSizeInch = (attributes = [], included = []) =>
  createFormattedAttributeObject({
    attributes: getAttributeItemsByGroup({
      attributes,
      group: BIKE_ATTRIBUTES.TYPE.ITEM_WHEEL_SIZE_INCH,
    }),
    included,
  })

export const getProductVariantProperties = ({ relatedProductProperties, relatedAttributes }) => {
  const props = getAttributeItemsByGroup({
    attributes: relatedProductProperties,
    group: API_CONSTANTS.AIMEOS.PRODUCT_PROPERTY.GROUP.PRODUCT_VARIANTS,
  })
  const attributes = getAttributeItemsByGroup({
    attributes: relatedAttributes,
    group: BIKE_ATTRIBUTES.GROUP.PRODUCT_VARIANTS,
  })
  return [...props, ...attributes]
}
// get(getFormattedFrameSizeAttributes(attributes), [
//   BIKE_ATTRIBUTES.TYPE.ITEM_FRAME_SIZE_CODE,
//   API_CONSTANTS.AIMEOS.ATTRIBUTE.ATTRIBUTE.LABEL,
// ])

export const getBrand = attributes => {
  const brandObject = head(
    getAttributeItemsByGroup({ attributes, group: BIKE_ATTRIBUTES.GROUP.BRAND }),
  )
  const type = get(brandObject, API_CONSTANTS.TYPE, '')
  const path =
    type === API_CONSTANTS.AIMEOS.TYPE.PRODUCT_PROPERTY
      ? API_CONSTANTS.AIMEOS.PRODUCT_PROPERTY.PATHS.VALUE
      : API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.LABEL

  return get(brandObject, path, '')
}

export const isArchiveItem = attributes => {
  const archiveAttribute = head(
    getAttributeItemsByGroup({ attributes, group: BIKE_ATTRIBUTES.GROUP.ARCHIVE }),
  )
  return !isUndefined(archiveAttribute)
}

export const getArticleType = attributes => {
  const articleType = head(
    getAttributeItemsByGroup({ attributes, group: [BIKE_ATTRIBUTES.TYPE.ARTICLE_TYPE] }),
  )
  return get(articleType, API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.CODE)
}

export const getProductNameInternal = attributes => {
  const productNameInternalObject = head(
    getAttributeItemsByGroup({
      attributes,
      group: BIKE_ATTRIBUTES.TYPE.PRODUCT_NAME_INTERNAL,
    }),
  )

  return get(productNameInternalObject, API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.LABEL)
}

export const getCategory = ({ attributes, included }) => {
  let category = createFormattedCategoryAttributeObject({
    attributes: getAttributeItemsByGroup({ attributes, group: [BIKE_ATTRIBUTES.TYPE.CATEGORY] }),
    included,
  })

  return category
}

export const getProductBidexCode = attributes => {
  const bidexCode = head(
    getAttributeItemsByGroup({ attributes, group: BIKE_ATTRIBUTES.GROUP.BIDEXCODE }),
  )
  return get(bidexCode, API_CONSTANTS.AIMEOS.ATTRIBUTE.PATHS.CODE)
}
